import { mutationOptions, useMutation } from '@tanstack/react-query';
import { Application } from 'merchant-api/types';
import { Operation } from 'rfc6902';
import { queryClient } from 'merchant-api';
import { unifiedApiClient } from './client';

interface PatchAppDataRequest {
  id: string;
  patches: Operation[];
}

const patchAppData = async ({ id, patches }: PatchAppDataRequest) => {
  const { data } = await unifiedApiClient.PATCH('/client/application/v1/{applicationId}/data', {
    params: { path: { applicationId: id } },
    headers: { 'Content-Type': 'application/json-patch+json' },
    body: patches as never,
  });
  return data as unknown as Application;
};

const patchAppDataWithCache = ({ id, patches }: PatchAppDataRequest) => {
  return patchAppData({ id, patches }).then((application) => {
    queryClient.setQueryData(['app', id], application);
    return application;
  });
};

export const patchAppDataOpts = () =>
  mutationOptions<Application, Error, PatchAppDataRequest>({
    mutationFn: patchAppDataWithCache,
  });

export default patchAppData;
